import { Controller } from "@hotwired/stimulus"

// Shows a note when a member has ticked neither SMS nor email, so the choice
// is a conscious one rather than an oversight.
//
// Deliberately non-blocking: not choosing a channel is a legitimate answer.
// The note lives in an aria-live region so it is announced when it appears,
// and it is only a note — nothing about it prevents submitting the form.
export default class extends Controller {
  static targets = ["channel", "notice"]

  connect() {
    this.update()
  }

  update() {
    const noneChosen = this.channelTargets.every((box) => !box.checked)
    this.noticeTarget.hidden = !noneChosen
  }
}
